module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\"><path fill=\"currentColor\" d=\"M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-1.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17zm-.47-4.97a.75.75 0 0 1-1.06-1.06l5-5a.75.75 0 0 1 1.06 1.06l-5 5zm-1.06 0l-2.5-2.5c-.7-.7.35-1.77 1.06-1.06l2.5 2.5c.7.7-.35 1.77-1.06 1.06z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/icons/svg/icon-tick-circle.svg
// module id = 915
// module chunks = 0